import { useState } from 'react';
import { differenceInDays, addDays, format, parse, isValid } from 'date-fns';
import './ToolStyles.css';

type CalcMode = 'interval' | 'add' | 'age';

const DateCalculator = () => {
    const [mode, setMode] = useState<CalcMode>('interval');
    const [date1, setDate1] = useState('');
    const [date2, setDate2] = useState('');
    const [days, setDays] = useState(0);
    const [result, setResult] = useState('');

    const today = format(new Date(), 'yyyy-MM-dd');

    const calculate = () => {
        if (mode === 'interval') {
            const d1 = parse(date1, 'yyyy-MM-dd', new Date());
            const d2 = parse(date2, 'yyyy-MM-dd', new Date());
            if (!isValid(d1) || !isValid(d2)) { setResult('请输入有效日期'); return; }
            const diff = Math.abs(differenceInDays(d2, d1));
            setResult(`相差 ${diff} 天（约 ${Math.floor(diff / 30)} 个月 ${diff % 30} 天）`);
        } else if (mode === 'add') {
            const d = parse(date1, 'yyyy-MM-dd', new Date());
            if (!isValid(d)) { setResult('请输入有效日期'); return; }
            const target = addDays(d, days);
            setResult(format(target, 'yyyy-MM-dd') + ` (${days >= 0 ? '之后' : '之前'} ${Math.abs(days)} 天)`);
        } else {
            const d = parse(date1, 'yyyy-MM-dd', new Date());
            if (!isValid(d)) { setResult('请输入有效出生日期'); return; }
            const now = new Date();
            let age = now.getFullYear() - d.getFullYear();
            const monthDiff = now.getMonth() - d.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < d.getDate())) age--;
            setResult(`年龄：${age} 岁`);
        }
    };

    return (
        <div className="tool-container">
            <div className="button-group">
                {[
                    { key: 'interval' as CalcMode, label: '日期间隔' },
                    { key: 'add' as CalcMode, label: '日期推算' },
                    { key: 'age' as CalcMode, label: '年龄计算' },
                ].map((m) => (
                    <button
                        key={m.key}
                        className={`mode-button ${mode === m.key ? 'active' : ''}`}
                        onClick={() => { setMode(m.key); setResult(''); }}
                    >
                        {m.label}
                    </button>
                ))}
            </div>

            {mode === 'interval' && (
                <>
                    <div className="input-group">
                        <label className="input-label">起始日期</label>
                        <input className="tool-input" type="date" value={date1}
                            onChange={(e) => setDate1(e.target.value)} />
                    </div>
                    <div className="input-group">
                        <label className="input-label">结束日期</label>
                        <input className="tool-input" type="date" value={date2}
                            onChange={(e) => setDate2(e.target.value)} />
                    </div>
                </>
            )}

            {mode === 'add' && (
                <>
                    <div className="input-group">
                        <label className="input-label">基准日期</label>
                        <input className="tool-input" type="date" value={date1}
                            onChange={(e) => setDate1(e.target.value)} />
                    </div>
                    <div className="input-group">
                        <label className="input-label">偏移天数（负数表示之前）</label>
                        <input className="tool-input" type="number" value={days}
                            onChange={(e) => setDays(Number(e.target.value))}
                            placeholder="输入天数..." />
                    </div>
                </>
            )}

            {mode === 'age' && (
                <div className="input-group">
                    <label className="input-label">出生日期</label>
                    <input className="tool-input" type="date" value={date1} max={today}
                        onChange={(e) => setDate1(e.target.value)} />
                </div>
            )}

            <button className="tool-button primary" onClick={calculate}>计算</button>

            {result && <div className="tool-output large" style={{ textAlign: 'center' }}>{result}</div>}
        </div>
    );
};

export default DateCalculator;
